import { BaseActivityEvent } from './BaseActivityEvent'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleAIRevisionAcceptedEvent } from './Types'
import { RevisionType } from 'components/BlazeCommandLine/Types'
import { ProseDisplay } from 'common/ProseInput/ProseDisplay'
import { schema } from 'prose-core'
import { RevisionTypeIcon } from 'components/RevisionTypeIcon/RevisionTypeIcon'
import { EventIconContainer } from 'components/ActivityEvent/EventIconContainer'

interface Props extends ActivityEventPosition {
  event: ArticleAIRevisionAcceptedEvent
}

export const revisionTypeEvents = (revisedContentType: string) => ({
  [RevisionType.CUSTOM_PROMPT]: ` updated ${revisedContentType} with this prompt`,
  [RevisionType.CHANGE_LENGTH]: ` changed the length of ${revisedContentType}`,
  [RevisionType.CHANGE_TONE]: ` changed the tone of ${revisedContentType}`,
  [RevisionType.TRANSLATE]: ` translated ${revisedContentType}`,
  [RevisionType.CUSTOM_DESIGN]: ``, // will not be used on docs
})

const revisedContentType = {
  [schema.nodes.unordered_list.name]: 'a list in this doc',
  [schema.nodes.list_item.name]: 'a list in this doc',
  [schema.nodes.paragraph.name]: 'a paragraph in this doc',
  [schema.nodes.heading.name]: 'a heading in this doc',
}

const ArticleAIRevisionAccepted = ({ event, ...props }: Props) => {
  const { user, data } = event

  return (
    <BaseActivityEvent
      {...props}
      icon={
        <EventIconContainer>
          <RevisionTypeIcon revisionType={event.data.revision_type} />
        </EventIconContainer>
      }
      timestamp={event.timestamp}
      content={
        <>
          <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} />
          {`${
            revisionTypeEvents(revisedContentType[event.data.revised_content_type] || 'some text in this doc')[
              data.revision_type
            ]
          }`}
        </>
      }
      message={data.custom_prompt && <ProseDisplay html={data.custom_prompt} />}
    />
  )
}

export { ArticleAIRevisionAccepted }
